module.exports = __webpack_public_path__ + "media/images/logo_header-195c5954d5993b9fcf7c6450dc08c7e2.png";